import React from "react";
import { brand } from "../mock";
import { useTheme } from "../theme/ThemeProvider";

const Logo = ({ variant = "light", size = 40 }) => {
  const { theme } = useTheme();
  const isDarkTheme = theme === "dark";
  const dark = variant === "dark" || isDarkTheme;
  const primary = dark ? "#ffffff" : "#0B1B3B";
  const accent = "#1E56E3";
  return (
    <a href="/" className="flex items-center gap-3">
      <div
        className="rounded-lg overflow-hidden bg-white flex items-center justify-center shrink-0"
        style={{ width: size, height: size }}
      >
        <img
          src={brand.logoUrl}
        alt="V4 Data And AI Solutions"
          className="w-full h-full object-contain"
          loading="eager"
        />
      </div>
      <span className="flex flex-col leading-none">
        <span className="font-extrabold text-[15px]" style={{ color: primary }}>
          V4 Data <span style={{ color: accent }}>and AI</span>
        </span>
        <span className="text-[10px] tracking-[0.18em] mt-1" style={{ color: dark ? "#B8C4E0" : "#66738F" }}>
          SOLUTIONS
        </span>
      </span>
    </a>
  );
};

export default Logo;
